// extracted by mini-css-extract-plugin
module.exports = {"svg":"cloud-four_svg__3kB8L"};